import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const mqttsession = localStorage.getItem('mqttsession');
if (!mqttsession){
  localStorage.setItem('mqttsession', Date.now().toString());
}

// The Angular service worker (ngsw-worker.js) is registered by
// ServiceWorkerModule.register() in app.module.ts — no manual registration here.
// Native (Capacitor) builds disable it there via Capacitor.isNativePlatform().

// Setting swEnabled: false only stops FUTURE registrations — a worker already
// installed on a device keeps running and keeps intercepting fetches forever,
// so the kill-switch alone cannot heal an affected register. Tear down any
// existing registration and its caches on startup. Unregister only takes effect
// for the next navigation, hence the one-time reload once something was removed.
if (!environment.swEnabled && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then(regs => Promise.all(regs.map(r => r.unregister())))
    .then(async (results) => {
      const removedWorker = results.some(Boolean);
      if ('caches' in window) {
        const keys = await caches.keys();
        // Only ngsw's own caches; leave anything else on the origin alone.
        await Promise.all(
          keys.filter(k => k.startsWith('ngsw:')).map(k => caches.delete(k)),
        );
      }
      // sessionStorage so a single reload cannot become a loop if a worker
      // somehow survives — the guard is cleared with the tab, not persisted.
      if (removedWorker && !sessionStorage.getItem('swPurged')) {
        sessionStorage.setItem('swPurged', '1');
        document.location.reload();
      }
    })
    .catch(() => {
      /* SW APIs unavailable or blocked — nothing to clean up. */
    });
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => {
    console.log('App bootstrap issue:', err?.message || err);
  });
